import { FormControlTextField } from 'shared/ui/form-elements';
import { FormControl, FormField, FormItem, FormLabel } from 'shared/ui/form';
import { Checkbox } from 'shared/ui/checkbox';
import { useFormContext } from 'react-hook-form';
import type { PostgresConfigWithInstances } from '@/enteties/postgresql/model';
import { InfoTooltip } from 'shared/ui/tooltips';
import * as m from '@paraglide/messages';
import parse from 'html-react-parser';
import type { KeyboardEvent } from 'react';
import { Link } from '@/shared/ui/link';
import { DOCS_DOMAIN } from '@/shared/lib/util';
interface CnpgConfigFieldsProps {
  disabled: boolean;
  withInstances?: boolean;
}
export const CnpgConfigFields = ({
  disabled,
  withInstances = false
}: CnpgConfigFieldsProps) => {
  const form = useFormContext<PostgresConfigWithInstances>();
  const [enableSuperuserAccess] = form.watch(['enableSuperuserAccess']);
  const preventSpaces = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };
  return <>
      <div className="bg-accent rounded-md px-6 py-3 text-sm">
        <Link href={`${DOCS_DOMAIN}/databases/postgreSQL.html`} docs data-sentry-element="Link" data-sentry-source-file="cnpg-config-fields.tsx">
          Документация
        </Link>
      </div>
      {/* @ts-ignore */}
      <FormControlTextField endIcon={<InfoTooltip text={m.tab_dbConfig_version_hint()} />} name="postgresVersion"
    // control={form.control}
    value="cloudnative-pg:1.22.1" label="Postgres version" disabled data-sentry-element="FormControlTextField" data-sentry-source-file="cnpg-config-fields.tsx" />
      <FormControlTextField name="database" endIcon={<InfoTooltip text={m.tab_dbConfig_dbName_hint()} />} control={form.control} label={m.tab_dbConfig_dbName()} disabled={disabled} placeholder={m.tab_dbConfig_dbName_placeholder()} onKeyDown={preventSpaces} data-sentry-element="FormControlTextField" data-sentry-source-file="cnpg-config-fields.tsx" />
      <FormControlTextField name="dbUsername" endIcon={<InfoTooltip text={m.tab_dbConfig_dbUsername_hint()} />} control={form.control} label={m.tab_dbConfig_dbUsername()} disabled={disabled} placeholder={m.tab_dbConfig_dbUsername_placeholder()} onKeyDown={preventSpaces} data-sentry-element="FormControlTextField" data-sentry-source-file="cnpg-config-fields.tsx" />
      <br />
      {withInstances && <FormControlTextField name="dbPassword" endIcon={<InfoTooltip text={m.tab_dbConfig_dbPassword_hint()} />} type="password" control={form.control} placeholder={m.tab_dbConfig_dbPassword_placeholder()} label={m.tab_dbConfig_dbPassword()} />}
      {withInstances && <FormControlTextField name="instances" endIcon={<InfoTooltip text={m.tab_dbConfig_instances_hint()} />} type="number" control={form.control} placeholder={m.tab_dbConfig_instances_placeholder()} label={m.tab_dbConfig_instances()} />}
      <FormField name="enableSuperuserAccess" control={form.control} render={({
      field
    }) => <FormItem className="flex flex-row items-center space-x-3 space-y-0">
            <FormControl>
              <Checkbox checked={field.value} onCheckedChange={field.onChange} disabled={disabled} />
            </FormControl>
            <FormLabel className="text-title5">
              {m.tab_dbConfig_superuser()}
            </FormLabel>
            <InfoTooltip text={<p className="text-body3">
                  {m.tab_dbConfig_superuser_hint()} <code>postgres</code>
                </p>} />
          </FormItem>} data-sentry-element="FormField" data-sentry-source-file="cnpg-config-fields.tsx" />
      {enableSuperuserAccess && <FormControlTextField name="superuserPassword" endIcon={<InfoTooltip text={<p className="text-body3">
                  {parse(m.tab_dbConfig_superuserPassword_hint())}
                </p>} />} control={form.control} label={m.tab_dbConfig_superuserPassword()} placeholder={m.tab_dbConfig_superuserPassword_placeholder()} disabled={disabled} />}
    </>;
};